import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContent from './accordion-content';

const AccordionItem = ({ item, type, eventKey, redirectTo, selecteditems, section, isNojoomPageMaster }) => {
  const [showitem, setshowitem] = useState(false);

  useEffect(() => {
    try {
      if (selecteditems.indexOf(eventKey) != -1) {
        setshowitem(true);
      } else {
        setshowitem(false);
      }
    } catch (e) {
      // console.log(e);
    }
  }, [selecteditems]);

  return (
    <Accordion.Item className="accordion_item" eventKey={eventKey}>
      <Accordion.Header className="accordion_header">
        <h3 className="section_title mb-0">{item?.metadata?.title}</h3>
        <img
          src={process.env.PUBLIC_URL + '/assets/images/arrow_down_dark.svg'}
          alt=""
          title=""
        />
      </Accordion.Header>
      <Accordion.Body className="accordion_collapse">
        {showitem && (
          <AccordionContent
            item={item}
            type={type}
            redirectTo={redirectTo}
            section={section}
            isNojoomPageMaster={isNojoomPageMaster}
          />
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default AccordionItem;
